"use client";

import { useMarket } from "@features/market/useMarket";
import { useQuery } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

import { getCartCookie } from "@/utils/cart/getCartCookie";

import { getCartProductItems, getCartQuantity } from "../config/items";
import { cartKeys } from "../config/keys";
import { fetchCart } from "../services/fetchCart";

function subscribeToCartCookie() {
  return () => {};
}

function getClientHasCart() {
  return Boolean(getCartCookie()?.value);
}

function getServerHasCart() {
  return false;
}

export function useCart() {
  const locale = useMarket().locale;
  const hasCart = useSyncExternalStore(
    subscribeToCartCookie,
    getClientHasCart,
    getServerHasCart,
  );

  const query = useQuery({
    queryKey: cartKeys.cart(locale),
    queryFn: () => fetchCart(locale),
    enabled: hasCart,
  });

  const cart = query.data ?? null;
  const items = getCartProductItems(cart?.items);

  return {
    cart,
    items,
    quantity: getCartQuantity(cart?.items),
    cartTotal: (cart?.totalGrossAmount ?? 0) - (cart?.totalFreightInclVat ?? 0),
    isEmpty: items.length === 0,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
